import { createContext, type Dispatch, type SetStateAction } from "react";

import type { WorkflowData } from "@/modules/workflow/components/WorkflowDetailsCard.tsx";

export interface WorkflowContextType {
  workflow: WorkflowData | null;
  setWorkflow: Dispatch<SetStateAction<WorkflowContextType["workflow"]>>;
  isLoading: boolean;
  setLoading: Dispatch<SetStateAction<WorkflowContextType["isLoading"]>>;
}

const noop = () => {};

export const initialWorkflowContextValue: WorkflowContextType = {
  workflow: null,
  setWorkflow: noop,
  isLoading: false,
  setLoading: noop,
};

export const WorkflowContext = createContext<WorkflowContextType>(initialWorkflowContextValue);
